import React, { useState } from 'react';
import { Columns3Cog, Eye, EyeOff } from 'lucide-react';
import { TextField } from 'components';
import { loginSchema } from 'utils';
import { useAuth } from 'hooks';
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";

export default function Login() {
    const {
        register,
        handleSubmit,
        formState: { errors },
    } = useForm({ resolver: yupResolver(loginSchema) });

    const { loginMutation } = useAuth()

    const onSubmit = (data) => {
        loginMutation.mutate(data);
    };

    const [showPassword, setShowPassword] = useState(false);
    // const [email, setEmail] = useState('');
    // const [password, setPassword] = useState('');

    // const handleSubmit = (e) => {
    //     e.preventDefault();
    //     console.log('Login attempted with:', { email, password });
    // };

    return (
        <form onSubmit={handleSubmit(onSubmit)}>
            <div className="bg-white rounded-xl shadow-2xl overflow-hidden w-full max-w-md">
                {/* Header */}
                <div className="bg-blue-900 px-8 py-8 text-center min-w-[350px]">
                    <div className="flex items-center justify-center gap-2 text-white">
                        <Columns3Cog className="color-white" />
                        <span className="text-lg font-semibold">SENBOOK SYSTEM</span>
                    </div>
                </div>

                {/* Form */}
                <div className="p-8 ">
                    <div className="space-y-6">
                        <div>
                            <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-2">
                                Email address
                            </label>
                            <TextField
                                type="email"
                                placeholder="Enter your email"
                                {...register("email")}
                            />
                            {errors.email && <p className="text-red-500">{errors.email.message}</p>}
                        </div>

                        {/* Password Field */}
                        <div>
                            <div className="flex justify-between items-center mb-2">
                                <label htmlFor="password" className="block text-sm font-medium text-gray-700">
                                    Password
                                </label>
                            </div>
                            <div className="relative">
                                <TextField
                                    type={showPassword ? 'text' : 'password'}
                                    id="password"
                                    placeholder="Enter your password"
                                    {...register("password")}
                                />
                                <button
                                    type="button"
                                    onClick={() => setShowPassword(!showPassword)}
                                    className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-500 hover:text-gray-700"
                                >
                                    {showPassword ? <EyeOff size={20} /> : <Eye size={20} />}
                                </button>
                            </div>
                        </div>

                        {/* Login Button */}
                        <button
                            type="submit"
                            disabled={loginMutation.isPending}
                            className="w-full bg-blue-900 text-white py-3 px-4 rounded-lg font-semibold hover:bg-[#0F1D4E] transition-colors focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2"
                        >
                            Log in
                        </button>
                    </div>

                    {loginMutation.isError && (
                        <div className="mt-6 text-center">
                            <p className="text-red-600 text-sm font-bold">Đăng nhập thất bại!</p>
                        </div>
                    )}

                </div>

                {/* Footer */}
                <div className="px-8 py-4 bg-gray-50 text-center">
                    <p className="text-xs text-gray-500">
                        2025 © HRM Solutions
                    </p>
                </div>
            </div>
        </form>
    );
}


